export default (subscription) =>
  subscription.billingType === "ANNUAL"
    ? "Annual subscription"
    : "Monthly subscription";
